import React from 'react';
import { MailIcon, PhoneIcon, MapPinIcon, ArrowUpIcon } from 'lucide-react';
const quickLinks = [{
  label: 'Home',
  href: '#'
}, {
  label: 'Our Restaurants',
  href: '#businesses'
}, {
  label: 'About Us',
  href: '#'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="bg-[#1d1d1f] text-white border-t-4 border-[#c9a961]" data-id="element-59">
      <div className="max-w-7xl mx-auto px-6 py-20" data-id="element-60">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 lg:gap-24" data-id="element-61">
          {/* Brand */}
          <div data-id="element-62">
            <div className="font-display text-[32px] font-bold tracking-tight text-white mb-6 flex items-center gap-2" data-id="element-63">
              <span className="text-[#c9a961] text-4xl" data-id="element-64">BV</span>
              <span className="tracking-widest uppercase text-sm font-sans mt-1" data-id="element-65">
                Group
              </span>
            </div>
            <p className="text-[#86868b] text-[16px] leading-relaxed mb-8 max-w-sm" data-id="element-66">
              Premier hospitality management company with a diverse portfolio of
              restaurants and entertainment venues across Thailand.
              <br data-id="element-67" />
              <br data-id="element-68" />
              Defining luxury since 2004.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-69">
            <h4 className="font-display text-[20px] text-white mb-8" data-id="element-70">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-71">
              {quickLinks.map(link => <li key={link.label} data-id="element-72">
                  <a href={link.href} className="text-[#86868b] text-[15px] hover:text-[#c9a961] transition-colors duration-300 flex items-center gap-2 group" data-id="element-73">
                    <span className="w-0 group-hover:w-4 h-[1px] bg-[#c9a961] transition-all duration-300" data-id="element-74" />
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-75">
            <h4 className="font-display text-[20px] text-white mb-8" data-id="element-76">
              Contact Us
            </h4>
            <ul className="space-y-6" data-id="element-77">
              <li className="flex items-start gap-4 group" data-id="element-78">
                <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center shrink-0 group-hover:bg-[#c9a961]/20 transition-colors duration-300" data-id="element-79">
                  <MapPinIcon className="w-5 h-5 text-[#c9a961]" data-id="element-80" />
                </div>
                <span className="text-[#86868b] text-[15px] leading-relaxed group-hover:text-white transition-colors duration-300" data-id="element-81">
                  629, Phetchburi 31 Road, Makassan, Ratchathewi, Bangkok 10400
                </span>
              </li>
              <li className="flex items-center gap-4 group" data-id="element-82">
                <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center shrink-0 group-hover:bg-[#c9a961]/20 transition-colors duration-300" data-id="element-83">
                  <MailIcon className="w-5 h-5 text-[#c9a961]" data-id="element-84" />
                </div>
                <a href="mailto:bvgroupthailand@gmail.com" className="text-[#86868b] text-[15px] hover:text-white transition-colors duration-300" data-id="element-85">
                  bvgroupthailand@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-4 group" data-id="element-86">
                <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center shrink-0 group-hover:bg-[#c9a961]/20 transition-colors duration-300" data-id="element-87">
                  <PhoneIcon className="w-5 h-5 text-[#c9a961]" data-id="element-88" />
                </div>
                <a href="tel:+66811770305" className="text-[#86868b] text-[15px] hover:text-white transition-colors duration-300" data-id="element-89">
                  +66 811 770 0305
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10 bg-black" data-id="element-90">
        <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-91">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[#86868b] text-[13px] tracking-wide" data-id="element-92">
            <p data-id="element-93">© 2026 BV Group Hospitality. All rights reserved.</p>
            <div className="flex items-center gap-6" data-id="element-94">
              <p data-id="element-95">Design by Custom Service Solutions • AG</p>
              <button onClick={scrollToTop} className="w-10 h-10 border border-white/10 flex items-center justify-center hover:bg-[#c9a961] hover:text-black hover:border-[#c9a961] transition-all duration-300" aria-label="Scroll to top" data-id="element-96">
                <ArrowUpIcon className="w-4 h-4" data-id="element-97" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}